import Icon from '@ant-design/icons'
import { ReactComponent as CopyIconSvg } from '../assets/icons/Copy.svg'
import { ReactNode } from 'react'

interface ICopyProps {
  text: string
  size?: number
  children?: ReactNode
}

export const Copy = ({ text, size, children }: ICopyProps): JSX.Element => {
  const onClick = async (): Promise<void> => {
    try {
      const type = 'text/plain'
      const blob = new Blob([text], { type })
      const data = [new ClipboardItem({ [type]: blob })]
      await navigator.clipboard.write(data)
    } catch (error) {
      console.log('Error when copying', error)
    }
  }
  return <div onClick={onClick} style={{ cursor: 'pointer' }}><Icon component={CopyIconSvg} style={{
    fontSize: size,
    lineHeight: size
  }}/> {children}</div>
}
